<div class="flex gap-15">
  <div>
    @if (usuario.extensaoImg) {
      <img class="container-img cursor-pointer" [src]="gerarUrlImg()" alt="Foto do usuário" role="button" tabindex="0" (click)="fileInputUsu.click()" (keydown.enter)="fileInputUsu.click()">
      <input type="file" accept="image/*" #fileInputUsu (change)="selecionarFotoUsuario($event);" hidden="" />
    }
    @else {
      <img class="container-img" src="assets/sem-img.svg" alt="Sem foto de usuário">
    }
  </div>
  <div class="flex-direction-column gap-5">
    <div class="flex gap-10 align-center">
      <span class="font-14 weight-700">{{ usuario.nome ?? '--' }}</span>
      <img src="assets/icones/phone-user.svg" alt="">
    </div>
    <div class="flex gap-10 align-center">
      <img src="assets/icones/phone.svg" alt="">
      <span class="font-10 weight-400">{{ (usuario.telefone | celularMask) ?? '--' }}</span>
    </div>
    <div class="flex gap-10 align-center">
      <img src="assets/icones/envelope-roxo.svg" alt="">
      <span class="font-10 weight-400">{{ usuario.email ?? '--' }}</span>
    </div>
    <div class="flex gap-10 align-center">
      <img src="assets/icones/cracha-perfil.svg" alt="">
      <span class="font-10 weight-400">{{ usuario.perfil?.nome ?? '--' }}</span>
    </div>
  </div>
</div>
